import { render, staticRenderFns } from "./NetworksProvider.vue?vue&type=template&id=82ca7eda&"
import script from "./NetworksProvider.vue?vue&type=script&lang=js&"
export * from "./NetworksProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports